
import GalleryImport from "../../../assets/filled/GalleryImport.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryImportIcon({ className, dataTestid = "GalleryImportIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryImport data-testid={dataTestid} className={classes} {...rest} />
  );
}
